<template>
  <div>
    <div style="position: relative;">
      <slot name="header" v-if="!isSorting"></slot>
      <span
        class="btn btn-secondary filter-btn"
        v-on:click="startSorting"
        v-if="showStartSortingButton"
        title="Sort items"
        ><i class="fas fa-bars"></i
      ></span>
    </div>
    <div
      class="row justify-content-center add-btn-wrapper"
      v-if="!isCancellable"
    >
      <span
        class="btn btn-secondary col-11 col-md-5 btn-add-subitem mb-4 mt-3"
        v-on:click="stopSorting"
        v-if="isSorting"
        title="Save sorting"
        ><i class="fas fa-bars pr-2"></i> Save sorting
        <i class="fas fa-bars pl-2"></i
      ></span>
    </div>
    <div
      class="row justify-content-center add-btn-wrapper"
      v-if="isCancellable && isSorting"
    >
      <span
        class="btn btn-primary col-5 col-md-2 btn-add-subitem mt-3 mb-4 mr-3"
        v-on:click="stopSorting"
        title="Save sorting"
        ><i class="fas fa-bars pr-2"></i> Save sorting
      </span>
      <span
        class="btn btn-primary white delete col-5 col-md-2 btn-add-subitem mt-3 ml-3 mb-4"
        v-on:click="cancelSorting"
        title="Cancel sorting"
        ><i class="fas fa-bars pr-2"></i> Cancel sorting
      </span>
      <span
        class="btn btn-primary white delete col-xs-2 mt-3 ml-3 mb-4"
        title="Reset sort order to default"
        v-on:click="resetSorting"
        v-if="isReinitable"
        ><i class="fas fa-undo"></i
      ></span>
    </div>
    <div v-if="isSorting" class="list-group">
      <SlickList lockAxis="y" v-model="listToSort">
        <SlickItem
          v-for="(item, index) in listToSort"
          :index="index"
          :key="item.sortableKey"
          class="list-group-item"
        >
          {{ item.sortableTitle }}
          <!-- {{ item.sortableKey }} -->
        </SlickItem>
      </SlickList>
    </div>
    <slot name="default" v-if="!isSorting"></slot>

    <div
      id="sortableConfirmationModal"
      class="modal"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Resetting sort</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Resetting the sort will set the sort order to 1000 for each
              item.<br />
              Please confirm.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="resetSortConfirmed"
            >
              Reset sort order
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import en from './sortable-en.json';
import fr from './sortable-fr.json';
import helpers from '@mixins/helpers.js';
export default {
  mixins: [helpers],
  name: 'volcan-sortable',
  beforeMount() {
    this.$i18n.add('fr', fr);
    this.$i18n.add('en', en);
  },
  props: {
    list: Array,
    getResForSortable: Function,
    title: String,
    titleAlt: String,
    languageIdActive: 0,
    startingSort: {
      type: Function,
      default() {}
    },
    stoppedSort: {
      type: Function,
      default() {}
    },
    resetSort: {
      type: Function,
      default() {}
    },
    isSortable: {
      type: Boolean,
      default: true
    },
    isCancellable: {
      type: Boolean,
      default: false
    },
    isReinitable: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'list',
    event: 'list:change'
  },
  data() {
    return {
      isSorting: false,
      count: 1
    };
  },
  mounted() {},
  computed: {
    listToSort: {
      get: function() {
        var nList = this.list.map(obj => ({
          ...obj,
          sortableKey: obj.sortableKey || this.uuidv4(),
          sortableTitle: this.getText(obj)
        }));
        return nList;
      },
      set: function(value) {
        this.$emit('list:change', value);
      }
    },
    showStartSortingButton() {
      return !this.isSorting && this.isSortable;
    }
  },
  methods: {
    removeReturns(s) {
      return s.replace(/\s+/g, ' ').trim();
    },
    startSorting() {
      this.startingSort();
      this.isSorting = true;
    },
    stopSorting() {
      this.stoppedSort(this.listToSort);
      this.isSorting = false;
    },
    resetSorting() {
      window.$('#sortableConfirmationModal').modal('show');
    },
    resetSortConfirmed() {
      window.$('#sortableConfirmationModal').modal('hide');
      this.resetSort();
      this.isSorting = false;
    },
    cancelSorting() {
      this.isSorting = false;
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    getText(el) {
      var shouldGetRes = window._.isFunction(this.getResForSortable);

      var res = shouldGetRes
        ? this.getResForSortable(el, this.languageIdActive)
        : el;
      var title = res[this.title] || '';
      if (title !== '') {
        return title;
      }

      var titleAlt = res[this.titleAlt] || this.count;
      this.count++;
      return window._.truncate(titleAlt, { length: 225, separator: ' ...' });
    }
  }
};
</script>
<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}

.filter-btn {
  position: absolute;
  top: 3px;
  right: 20px;
  z-index: 9999;
}

.has-sort .filter-btn {
  top: 20px;
}

.has-sort .search-form-ctn {
  padding-right: 70px;
}
</style>



// WEBPACK FOOTER //
// components/Custom/Sortable/sortable.vue